import * as React from "react";

const SayLogo = () => (
  <svg
    width="100%"
    height="25"
    viewBox="0 0 103 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1050 -701)" fill="#FFF">
        <g id="Group-3" transform="translate(1050 701)">
          <path d="M47.0889977,14.6407792 L59.0045795,14.6407792 L53.0467886,5.40356645 L47.0889977,14.6407792 Z M56.9884285,0.304134216 L72.4493276,23.8770416 L72.4493276,24.4413316 L65.2827096,24.4413316 L62.3012238,19.7963726 L43.7880362,19.7963726 L40.8100042,24.4413316 L33.6347517,24.4413316 L33.6347517,23.8849042 L49.099968,0.304134216 L56.9884285,0.304134216 Z M15.1396965,9.37027152 C8.64397748,9.37027152 6.3756997,9.28386976 6.3756997,7.38303091 C6.3756997,5.7094287 8.59907819,5.1711457 15.7959169,5.1711457 C23.3614479,5.1711457 29.4383946,7.18344283 29.4383946,7.18344283 L29.9072468,7.02791965 L29.9072468,1.93712759 C29.9072468,1.93712759 24.3181482,0 15.6663997,0 C7.46191723,0 0,1.25023355 0,8.24532053 C0,15.1427735 5.39914007,15.2343594 17.1653454,15.2343594 C23.0739197,15.2343594 25.8637201,15.2093029 25.8637201,17.2665289 C25.8637201,19.1587276 22.4910923,19.7065148 15.404775,19.7065148 C5.96642537,19.7065148 0.588008058,17.2950415 0.588008058,17.2950415 L0.129517193,17.5230558 L0.129517193,22.8385788 L0.324656431,22.8999241 C4.3699101,24.1769422 9.81913015,24.8837086 15.6663997,24.8837086 C27.2797747,24.8837086 32.2394198,23.1237046 32.2394198,16.7014614 C32.2394198,10.2161448 27.689049,9.37027152 15.1396965,9.37027152 Z M102.446373,0.302406181 L102.446373,0.873521854 L102.360028,0.970291832 L87.6693247,16.8483444 L87.6693247,24.4430596 L80.9344307,24.4430596 L80.9344307,16.8483444 L66.1539286,0.873521854 L66.1539286,0.302406181 L73.6978733,0.302406181 L73.7436361,0.352519205 L84.2984239,12.0297179 L94.8989744,0.302406181 L102.446373,0.302406181 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default SayLogo;



// WEBPACK FOOTER //
// ./src/pages/Index/SayLogo.tsx